<template>
    <transition name="modal__animation" >
        <div v-if="isOpen" class="modal__container"  >
            <div class="modal__inner">
                <div v-if="closeButton" class="modal__close"><i class="material-icons pedo" @click.stop="close()" >close</i></div>
                <slot /> <!-- Contenido Modal  -->
            </div>
        </div>
    </transition>
</template>

<script>
export default{
    props: {
        isOpen: {
            type: Boolean
        },
        closeButton: {
            type: Boolean,
            default: true
        }
    },
    emits: ['close'],
    setup(props, {emit}){
        const close = () => {
            emit("close")
        }

        return{
            close
        }
    }
}

</script>

<style lang="scss" >
@import "@/styles/main.scss";

.modal__container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba($color: #000000, $alpha: .3);
    z-index: 100000;
    .modal__inner{
        position:relative;
        padding: 16px;
        // width: 96%;
        width: max-content;
        height: fit-content;
        max-height: 94vh;
        overflow: visible;
        background-color: #ffF;
        border-radius: 10px;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

        @media (max-width:980px) {
            width: 100%;            
        }

        &::-webkit-scrollbar-track {
            border-radius: 100px;
            background-color: rgba(0,0,0,.1);
        }
        &::-webkit-scrollbar {
            width: 10px;
            height: 10px;
            background-color: transparent;
            margin: 4px 0;
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 100px;
            background: map-get($dark, 400);
            position: absolute;
        }
        .modal__close{
            display: flex;
            justify-content: flex-end;
            //margin-bottom: -8px;
            .material-icons{
                font-size: 20px;
                cursor: pointer;
            }
        }
    }
}

.modal__animation-enter-active,
.modal__animation-leave-active{
    transition: opacity .3s cubic-bezier(.52, .02, .19,  1.02)
}

.modal__animation-enter-from,
.modal__animation-leave-to{
    opacity: 0;
}
 
</style>